<template>

  <div>

    <h2>{{$t('title.accesses-for')}} | Controller: {{ swithc.controllerName }} | Switch: {{ swithc.name }}</h2>

    <single-access
      :access-holders="accessHolders"
      :unprocessed-accesses="unprocessedAccesses"
      :columns="['contact_name']"
      :switch-id="switchId" />

  </div>

</template>

<script>
import SingleAccess from './SingleAccess'
import findAll from 'service/findAll'
import findOne from 'service/findOne'

export default {
  name: 'single-switch-access',
  computed: {
    switchId () {
      return this.$route.params.id
    },
    accessHolders () {
      return this.mobiles.map(m => ({
        ...m,
        access: (m.mobileAccesses || []).find(a => a.switch_id === this.switchId)
      }))
    }
  },
  components: { SingleAccess },
  mixins: [
    findAll('mobiles'),
    findOne('switches', 'swithc', function () { return this.switchId }),
    findAll('pending-mobile-accesses', 'unprocessedAccesses', {
      filter (access) {
        return access.switch_id === this.switchId
      },
      map (access) {
        return { ...this.mobiles.find(m => m.id === access.mobile_id), access }
      }
    })
  ]
}
</script>



// WEBPACK FOOTER //
// SingleSwitchAccess.vue?2e842976